import { ManagementUnitsInfiniteView } from '@apps-common/apps/portal/pages/units/components/management/units-infinite'
import { ManagementUnitsTableView } from '@apps-common/apps/portal/pages/units/components/management/units-table'
import { MobileViewSwitcher } from '@apps-common/components/common/MobileViewSwitcher'

export const ManagementUnitsView = () => (
  <MobileViewSwitcher desktopView={<ManagementUnitsTableView />} mobileView={<ManagementUnitsInfiniteView />} />
)
